import React from 'react'
import { Skills, Testimonials, Works, Footer, Aboutme, Header } from './container/index';
import { Navbar } from './components/Navbar/index'

import "./App.scss"
const App = () => {
  return (
    <div className="app">
      <Navbar/> 
      <Header/>
      <Aboutme/>
      <Works/>
      <Skills/>
      <Testimonials/>
      <Footer/>
    </div>
  )
}

export default App
